export default {
    data: {
        key: 'gps',
        fields: [
            {
                key: 'gpId',
                name: 'Gp Id',
                description: '',
                group: 'Identification',
                type: 'int',
                validators: [
                    'unique',
                ],
                styles: [],
                mappers: {},
            },
            {
                key: 'name',
                name: 'Name',
                description: '',
                group: 'Identification',
                type: 'string',
                validators: [],
                styles: [],
                mappers: {},
            },
            {
                key: 'hqCountryId',
                name: 'Hq Country Id',
                description: '',
                group: 'General information',
                type: 'select',
                validators: [],
                styles: [],
                mappers: {},
            },
            {
                key: 'hqRegionId',
                name: 'Hq Region Id',
                description: '',
                group: 'General information',
                type: 'select',
                validators: [],
                styles: [],
                mappers: {},
            },
        ],
    },
}
